import { CreateGuestSessionDocument } from '@graphql/generated/graphql';

import { useInitializeSession } from '@services/AuthService/useInitializeSession';

import { useMutation } from '@apollo/client';

export const useLoginGuest = () => {
    const [createGuestSession, { error, reset }] = useMutation(
        CreateGuestSessionDocument,
        {
            context: {
                notifyOnError: true,
            },
            notifyOnNetworkStatusChange: true,
            onError: () => {},
        },
    );
    const { initializeSession } = useInitializeSession(
        createGuestSession,
        true,
    );

    return {
        cancelGuestLogin: reset,
        handleGuestLogin: initializeSession,
        loginGuestError: error,
    };
};
